<template>
	<div class="front-page">
		<!-- Render modules -->
		<template v-if="userTags.length">
			<div v-for="(module, index) in modules" :key="module._id" :id="'module_' + index" class="module__container">
				<transition name="scroll-y-reverse-transition">
					<v-container tag="section" fluid constrain grid-list-xl py-0 class="mb-12" v-if="!module.targeting || shouldSeeContentByTag(module.targeting)">
						<!-- Rendering the known modules -->
						<component :is="module.componentName" :module="module" :class="module.classObject" v-if="module.componentName" />
					</v-container>
				</transition>
			</div>
		</template>
	</div>
</template>

<script>
import { CoverImage, SearchLocation } from './components';
import { Banner, CallToAction, ScrollToDiv, SearchAndCoverImage, TextAndImage, CustomHtml, LastVisitedSalons } from '@/components/modules';

export default {
	name: 'front-page-view',
	components: {
		SearchLocation,
		CoverImage,
		TextAndImage,
		CallToAction,
		Banner,
		ScrollToDiv,
		SearchAndCoverImage,
		CustomHtml,
		LastVisitedSalons
	},
	data() {
		return {
			modules: []
		};
	},
	computed: {
		userTags() {
			return this.$store.state.user.userTags || [];
		}
	},
	methods: {
		shouldSeeContentByTag(targeting) {
			let userTags = this.userTags;
			let checkOK = true;
			targeting.forEach(tag => {
				if (!userTags.includes(tag)) {
					checkOK = false;
				}
			});
			return checkOK;
		},

		redirectToUrl() {
			//https://github.com/vuejs/vue-router/issues/1144
			const overrides = { redirectUrl: this.redirectUrl, currentForm: 'login' };
			this.$eventBus.$emit('login-dialog', true, overrides);
		}
	},
	beforeRouteEnter(to, from, next) {
		if (to.query) {
			if (to.query.redirectUrl) {
				next(vm => {
					vm.redirectUrl = to.query.redirectUrl;
					vm.redirectToUrl();
				});
			} else {
				next();
			}
		} else {
			next();
		}
	},
	async beforeCreate() {
		// Fetch modules
		let content = await this.$umbraco.GetFrontPageContent();
		this.modules = content.modules;
	}
};
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.front-page {
	.module {
		&__container {
			&:first-child {
				padding-top: 10vh;
				padding-bottom: 7vh;

				@media #{map-get($display-breakpoints, 'xs-only')} {
					padding-top: 0;
					padding-bottom: 2vh;
				}
			}
		}
	}
}
</style>
